import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
import { BRAND } from './salesData';
const CONTACTS = [{
  icon: MailIcon,
  label: 'Soporte y consultas',
  value: BRAND.email,
  href: `mailto:${BRAND.email}`,
  external: false
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  value: BRAND.instagramHandle,
  href: BRAND.instagramUrl,
  external: true
}, {
  icon: GlobeIcon,
  label: 'Sitio oficial',
  value: BRAND.siteLabel,
  href: BRAND.siteUrl,
  external: true
}];
export function Footer() {
  return <footer id="site-footer" className="border-t border-warm bg-bone py-12" data-id="element-181" data-mp="3lec7k9t840dr">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-182" data-mp="3lggez1qbzhis">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between sm:gap-12" data-id="element-183" data-mp="3qc40961ozqj0">
          <div data-id="element-184" data-mp="29ydxq3q81abh">
            <p className="font-display text-[1.3rem] tracking-tight text-charcoal" data-id="element-185" data-mp="29xvrqfdrbhqd">
              100 <span className="text-gold-deep" data-id="element-186" data-mp="2ezutjktum6l7">NY</span> Cookies
            </p>
            <p className="mt-1.5 font-sans text-[0.86rem] text-charcoal/55" data-id="element-187" data-mp="3lalfndz543tf">
              Aprendé a prepararlas y a ofrecerlas · Producto 100% digital
            </p>
            <p className="mt-5 font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/40" data-id="element-188" data-mp="3v7gfq1b2ac9t">
              Un producto de
            </p>
            <p className="mt-1 font-display text-[1.05rem] tracking-tight text-charcoal" data-id="element-189" data-mp="3q7bvc0718xeb">
              {BRAND.studio}
            </p>
          </div>

          <ul className="grid gap-4 sm:grid-cols-3 sm:gap-x-10" data-id="element-190" data-mp="34gxxkciex96">
            {CONTACTS.map(contact => {
            const Icon = contact.icon;
            return <li key={contact.href} data-id="element-191" data-mp="huo8ldw9zbzb">
                  <p className="font-sans text-[0.6rem] font-bold uppercase tracking-editorial text-charcoal/40" data-id="element-192" data-mp="cus0p3kgj0eh">
                    {contact.label}
                  </p>
                  <a href={contact.href} {...contact.external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="mt-1.5 inline-flex items-center gap-2 font-sans text-[0.88rem] font-medium text-charcoal/75 transition-colors duration-200 ease-out hover:text-gold-deep" data-id="element-193" data-mp="ms6ib6i49v8d">
                    <Icon className="h-4 w-4 shrink-0 text-gold-deep" aria-hidden data-id="element-194" data-mp="18kiyrfwdnvn1" />
                    <span className="break-all" data-id="element-195" data-mp="1clup5nn2skwa">{contact.value}</span>
                  </a>
                </li>;
          })}
          </ul>
        </div>

        <div className="mt-10 border-t border-warm pt-6" data-id="element-196" data-mp="1hiun1b9ruhcb">
          <p className="max-w-3xl font-sans text-[0.74rem] leading-relaxed text-charcoal/40" data-id="element-197" data-mp="1mjihk6x7lgba">
            100 New York Cookies es un producto digital de recetas y fundamentos de fabricación. Los
            resultados comerciales dependen de la ejecución y del mercado de cada persona. Antes de
            vender alimentos elaborados, verificá las normas que correspondan en tu ciudad o país.
          </p>
          <p className="mt-4 font-sans text-[0.74rem] text-charcoal/40" data-id="element-198" data-mp="2ag5csk60p0dh">
            © 2026 {BRAND.studio}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}